import { FC, memo } from 'react'

import { FormTitleProps } from './FormTitleProps'

import * as SC from './styles'

export const FormTitle: FC<FormTitleProps> = memo(({ bankName }) => (
  <SC.FormTitle>Welcome to {bankName} Onboarding</SC.FormTitle>
))
